/**
 * Platform detection for steering decisions (T27.2.10).
 *
 * The steering rule (Background § Platform-aware steering rule) needs to know
 * when we are in an Android *browser* — as opposed to the installed native
 * app, iOS, or desktop — so the in-app "Get the Android app" banner shows only
 * where it makes sense.
 *
 * `isNativePlatform` is reused from `routes/nativeGoogleSignIn` so there is no
 * duplicate Capacitor UA logic; the `!isNativePlatform()` half is what
 * suppresses the banner inside the installed app, whose WebView UA still
 * reports "Android".
 */

import { isNativePlatform } from '../routes/nativeGoogleSignIn';

/**
 * True only in an Android *web browser* — Android UA AND not the native shell.
 *
 * - Android browser (Chrome, Samsung Internet, …) → true → steer to the app.
 * - Installed native app → false (its UA says Android, but `isNativePlatform()`
 *   is true) → no self-referential "install the app" nudge.
 * - iOS / desktop → false (UA isn't Android) → PWA only.
 */
export function isAndroidBrowser(): boolean {
  return /android/i.test(navigator.userAgent) && !isNativePlatform();
}
